var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTheLineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 30,
    rx: 4.5,
    fill: "white",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 19V12H12C12.7467 12 13.4033 12.1467 13.97 12.44C14.5433 12.7333 14.9867 13.1433 15.3 13.67C15.62 14.1967 15.78 14.8067 15.78 15.5C15.78 16.1933 15.62 16.8033 15.3 17.33C14.9867 17.8567 14.5433 18.2667 13.97 18.56C13.4033 18.8533 12.7467 19 12 19H9.05ZM10.05 18.13H11.94C12.52 18.13 13.02 18.02 13.44 17.8C13.8667 17.58 14.1967 17.2733 14.43 16.88C14.6633 16.48 14.78 16.02 14.78 15.5C14.78 14.9733 14.6633 14.5133 14.43 14.12C14.1967 13.7267 13.8667 13.42 13.44 13.2C13.02 12.98 12.52 12.87 11.94 12.87H10.05V18.13ZM17.4117 19V12H18.4117V18.13H22.2017V19H17.4117Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTheLineActive);
export default __webpack_public_path__ + "static/media/downTheLineActive.fad838a19743822bc49d1112781c8241.svg";
export { ForwardRef as ReactComponent };